exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._9CxBO1HzQYreadMqNT0vs{font-weight:500;font-size:13px;line-height:14px;padding:15px 0 3px 0;display:flex;flex-wrap:wrap}.qlUb00o_DK7-07QHA67vQ{flex:1 1 50%;cursor:default;color:#616161;position:relative;margin-bottom:10px}.qlUb00o_DK7-07QHA67vQ._3t7b9HblUALfUSE00H8AJl{cursor:pointer}.qlUb00o_DK7-07QHA67vQ ._1kRemzPcMmuCxOfRdPDbpl{display:inline-block}.qlUb00o_DK7-07QHA67vQ .wlwEPcSlT6AtdFiRIcIlg{position:absolute}.qlUb00o_DK7-07QHA67vQ ._3eEvnEx5qI7luPZep-dtWh{display:inline-block;margin-left:18px}\n", ""]);

// Exports
exports.locals = {
	"TRouteMeta": "_9CxBO1HzQYreadMqNT0vs",
	"TRouteMetaItem": "qlUb00o_DK7-07QHA67vQ",
	"clickable": "_3t7b9HblUALfUSE00H8AJl",
	"container": "_1kRemzPcMmuCxOfRdPDbpl",
	"icon": "wlwEPcSlT6AtdFiRIcIlg",
	"text": "_3eEvnEx5qI7luPZep-dtWh"
};